import FixtureWidget from './components/FixtureWidget';
import StandingsWidget from './components/StandingsWidget';
import FixtureWidgetMulti from './components/FixtureWidgetMulti';
import StandingsWidgetMulti from './components/StandingsWidgetMulti';
import FixtureWidgetCricket from './components/FixtureWidgetCricket';
import FixtureWidgetTennis from './components/FixtureWidgetTennis';
import FixtureWidgetAllSports from './components/FixtureWidgetAllSports';

import JSONManager from './services/JSONManager';

import EventManager from './handlers/EventManager';
import FileManager from './handlers/FileManager';
import DataManager from './services/DataManager';

import './styles/index.scss';
import { PUBLIC_EVENTS, PRIVATE_EVENTS, EVENT_CALLBACK } from './handlers/EventManager/constants';
import { downloadObjectAsJson } from './helpers/tabConfigUtils';

class SportsManager {
  constructor(sportsManagerConfig = { player: true }) {
    this.eventManager = new EventManager();
    this.fallbackTextData = sportsManagerConfig.fallBackTextData;
    this.dataManager = new DataManager();
    window.dataManager = this.dataManager;
    this.subscribeToEvents();
    this.sportsManagerConfig = sportsManagerConfig;
    this.jsonManager = new JSONManager(this, sportsManagerConfig.jsonManagerConfig || {});

    // if (sportsManagerConfig.player) {
    //   this.loadLightStreamerSDK(() => {
    //     this.lightStreamManager = new LightStreamerManager(this, sportsManagerConfig.lightStreamerConfig || {});
    //   });
    // } else {
    //   this.jsonManager = new JSONManager(this, sportsManagerConfig.jsonManagerConfig || {});
    // }

    this.exportAllWidgets();
    this.subscriberMapping = {};

    let sportsSDKLogging = localStorage.getItem('SPORTS_SDK_LOG_MODE');
    if (sportsSDKLogging == 'true') {
      this.createDownloadLogsButton();
    }
  }

  static eventName = PUBLIC_EVENTS;

  createDownloadLogsButton() {
    var downloadBtn = document.createElement('button');
    downloadBtn.classList.add('sports-sdk-log-btn');
    downloadBtn.innerText = 'Get Logs';
    downloadBtn.addEventListener('click', (e) => {
      const currentDataLog = window.dataManager.getAllData();
      const fileName = `sports-sdk-log-${new Date().getTime()}`;
      downloadObjectAsJson(currentDataLog, fileName);
    });
    document.body.appendChild(downloadBtn);
  }

  exportAllWidgets() {
    this.FixtureWidget = FixtureWidget.bind(null, this);
    this.FixtureWidgetCricket = FixtureWidgetCricket.bind(null, this);
    this.FixtureWidgetTennis = FixtureWidgetTennis.bind(null, this);
    this.FixtureWidgetAllSports = FixtureWidgetAllSports.bind(null, this);
    this.StandingsWidget = StandingsWidget.bind(null, this);
    this.FixtureWidgetMulti = FixtureWidgetMulti.bind(null, this);
    this.StandingsWidgetMulti = StandingsWidgetMulti.bind(null, this);
  }

  getWidgetBySportsId() {
    if (this.sportsManagerConfig?.assetConfig?.sportId) {
      switch (this.sportsManagerConfig.assetConfig.sportId) {
        case '1':
          return FixtureWidgetCricket.bind(null, this);
        case '2':
          return FixtureWidget.bind(null, this);
        case '3':
          return FixtureWidgetTennis.bind(null, this);
        case '-1':
          return FixtureWidgetAllSports.bind(null, this);
        default:
          return FixtureWidgetAllSports.bind(null, this);
      }
    }
  }

  addEventListener(eventName, subscriberCallback) {
    this.subscriberMapping[eventName] = this.subscriberMapping[eventName] || [];
    if (typeof subscriberCallback === 'function') {
      this.subscriberMapping[eventName].push(subscriberCallback);
    }
  }

  subscribeToEvents() {
    this.eventManager.subscribeToEvents({
      eventType: EVENT_CALLBACK.PRIVATE_EVENTS,
      eventCallback: this.privateEventCallback.bind(this),
      senderName: 'SPORTS_MANAGER',
    });

    this.eventManager.subscribeToEvents({
      eventType: EVENT_CALLBACK.PUBLIC_EVENTS,
      eventCallback: this.publicEventCallback.bind(this),
      senderName: 'SPORTS_MANAGER',
    });
  }

  privateEventCallback(eventName, eventData) {
    switch (eventName) {
      case PRIVATE_EVENTS.TEST_START_PRIVATE: {
        console.log(eventName, eventData);
        break;
      }

      case PRIVATE_EVENTS.INITIAL_TAB_CONFIG: {
        console.log(eventName, eventData);
        break;
      }
    }
  }

  publicEventCallback(eventName, eventData) {
    const masterEventName = 'SPORTS_MANAGER_EVENT';
    switch (eventName) {
      case PUBLIC_EVENTS.TEST_START_PUBLIC: {
        console.log(eventName, eventData);
        break;
      }

      case PUBLIC_EVENTS.SPORTS_MANAGER_ERROR: {
        this.broadcastPublicEventsToClient(masterEventName, eventName, eventData);
        break;
      }

      case PUBLIC_EVENTS.SPORTS_MANAGER_SUCCESS: {
        this.broadcastPublicEventsToClient(masterEventName, eventName, eventData);
        break;
      }

      case PUBLIC_EVENTS.TAB_CONFIG_DATA_SUCCESS: {
        this.broadcastPublicEventsToClient(masterEventName, eventName, eventData);
        break;
      }

      case PUBLIC_EVENTS.FIXTURES_DATA_UPDATE: {
        this.broadcastPublicEventsToClient(masterEventName, eventName, eventData);
        break;
      }

      case PUBLIC_EVENTS.STANDINGS_UPDATE: {
        this.broadcastPublicEventsToClient(masterEventName, eventName, eventData);
        break;
      }

      case 'FIXTURES_DROPDOWN_EVENT': {
        this.broadcastPublicEventsToClient(masterEventName, eventName, eventData);
        break;
      }
    }
  }

  broadcastPublicEventsToClient(masterEventName, eventName, eventData) {
    const subscriberList = this.subscriberMapping[masterEventName];
    for (let i = 0; i < subscriberList?.length; i++) {
      if (typeof subscriberList[i] === 'function') {
        subscriberList[i].call(null, eventName, eventData);
      }
    }
  }

  loadLightStreamerSDK(callback) {
    if (typeof LightstreamerClient !== 'undefined') {
      this.LIGHT_STREAMER_SDK_LOADED = true;
      callback();
      return;
    }
    let fileManager = new FileManager();
    let lsFullUrl = `${fileManager.createLSFileUrl()}`;
    console.info('lsFullUrl', lsFullUrl);
    fileManager.loadLightStreamerSDK(
      lsFullUrl,
      () => {
        console.log('LightStreamer SDK Loaded');
        this.LIGHT_STREAMER_SDK_LOADED = true;
        callback();
      },
      this.onErrorCallBack
    );
  }

  onErrorCallBack = () => {
    this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS.SPORTS_MANAGER_ERROR, {
      errorCode: 'err_105',
      errorMessage: 'globalErrorManager: Unable to connect LightStreamer',
    });
  };

  loadSportsSDKCSS(callback) {
    let fileManager = new FileManager();
    let cssFullUrl = `${fileManager.createSDKCSSUrl()}`;
    console.info('cssFullUrl', cssFullUrl);
    fileManager.loadSportsSDKCss(cssFullUrl, () => {
      console.log('SDK CSS Loaded');
      callback();
    });
  }

  // registerErrorHandler() {
  //   window.addEventListener("error", (e) => {
  //     this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS.SPORTS_MANAGER_ERROR, { error: e?.error?.message });
  //     return false;
  //   })
  // }
}
if (
  typeof COMMITHASH !== 'undefined' &&
  typeof BRANCH !== 'undefined' &&
  typeof SPORTS_SDK_VERSION !== 'undefined' &&
  typeof SPORTS_SDK_BASE_URL !== 'undefined'
) {
  window.sportsSdkInfo = {
    commitHash: COMMITHASH,
    branch: BRANCH,
    sports_sdk_version: SPORTS_SDK_VERSION,
    sport_sdk_base_url: SPORTS_SDK_BASE_URL,
  };
}
window.SPORTS_MANAGER = SportsManager;
